import { useEffect } from 'react';
import AuthService from '../../services/auth/authService';

const DomainUrlRedirect = (props) => {
  const { searchParams = {}, pathname, url, authParamName } = props;
  const _url = url.startsWith('http') ? url : `${window.location.protocol}${url}`;

  useEffect(() => {
    const uri = new URL(_url);

    uri.pathname = pathname;
    const token = AuthService.getAuthToken(); //DONE: get token from store
    if (authParamName && token) {
      searchParams[authParamName] = token;
    }
    for (const paramName in searchParams) {
      uri.searchParams.append(paramName, searchParams[paramName]);
    }
    window.history.replaceState({ prevUrl: window.prevUrl }, '', window.prevUrl);
    window.location.assign(uri.href);
  });

  return <span data-test-component="DomainUrlRedirect"></span>;
};

export default DomainUrlRedirect;
